import { render, staticRenderFns } from "./dialogos.vue?vue&type=template&id=2d681b1c&scoped=true&"
import script from "./dialogos.vue?vue&type=script&lang=js&"
export * from "./dialogos.vue?vue&type=script&lang=js&"
import style0 from "./dialogos.vue?vue&type=style&index=0&id=2d681b1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d681b1c",
  null
  
)

export default component.exports